<template>
  <common-dialog ref="dialog" :title="title" :close-on-saved="false" width="1200px" :in-dialog="inDialog">
    <list ref="list" common :show-checkbox="multiple" :typeList="typeList" :checkbox-fixed="false" :show-status="false" @table-change="tableChange">
      <!-- <template #column>
        <slot name="column" />
        <el-table-column
          label="操作"
          align="center"
          width="60"
          fixed="right"
          v-if="selectable&&!multiple"
        >
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </template> -->
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button size="mini" type="primary" @click="selectMultiple" >确定</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "选择销售订单",
    },
    typeList: {
      default: () => [1,2,3]
    }
  },
  data(){
    return{
      data:[],
      commodityList:[],
      key:{
        SupplierId:"",
        SupplierName:""
      }
    }
  },
  methods: {
    tableChange(data){
       this.data=data
    },
    selectMultiple(){
      this.commodityList=[]
      this.key={
        SupplierId:"",
        SupplierName:""
      }
        this.data.forEach((e,index)=>{
          let a = 'expandtable'+index
          if(this.$refs.list.$refs.list.$refs['expandtable'+index]){
          let list =this.$refs.list.$refs.list.$refs['expandtable'+index].selection
          this.commodityList.push(...list)
          }
        })
        for (let index = 0; index < this.commodityList.length; index++) {
        if(this.key.SupplierId==""){
           this.key.SupplierId=this.commodityList[index].SupplierId
           this.key.SupplierName=this.commodityList[index].SupplierName
          }else if(this.key.SupplierId!=this.commodityList[index].SupplierId){
              this.$message.error("供应商必须一致")
              return
          }
        }
          this.onSelect({list:this.commodityList,Supplier:this.key})
    },
  },
};
</script>